enum ReturnDeclarationSkuRoutes {
  List = '/return-declarations-sku',
  Edit = '/return-declarations-sku/edit/:id',
  Add = '/return-declarations-sku/add',
}

export default ReturnDeclarationSkuRoutes
